import { SaveButton } from '@/components/_common';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import { FormattedMessage } from 'react-intl';
import ComplementCreateButton from '../Complements/ComplementCreateButton';
import LGPDTermModal from '../Complements/ComplementForm/LGPDTermModal';
import { useWorkorderDetailContext } from '../WorkorderDetailProvider';
import ComplementAuthorize from '../WorkOrderFooter/ComplementAuthorize';
import { useWorkorderForms } from '../WorkOrderFormProvider';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ComplemetPolicy from '../Complements/ComplementPolicy';
import { isAppPortocar } from '@/index';
import ComplementImportCilia from '../WorkOrderFooter/ComplementImportCilia';
import { ComplementOriginEnum } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';

interface Props {
  saveButtonIsDisabled?: boolean;
}

const WorkorderTabExtraAction: React.FC<Props> = ({ saveButtonIsDisabled }) => {
  const { submitAllForms, isLoading, hasFormChange } = useWorkorderForms();
  const [modalLgpdOpen, modalLgpdAction] = useDisclosure();

  const {
    workorder: { data: workorder },
    complement: { data: complement },
    isAlerted,
  } = useWorkorderDetailContext();

  const showAuthorizeButton =
    complement?.status === WorkOrderComplementStatus.Open;

  const showCreateComplementButton =
    complement?.status == WorkOrderComplementStatus.Authorized ||
    complement?.status == WorkOrderComplementStatus.Closed;

  const isImportCilia = complement?.origin === ComplementOriginEnum.Cilia;

  function onSave() {
    if (isAlerted) {
      modalLgpdAction.open();
    } else {
      submitAllForms();
    }
  }

  return (
    <>
      <SpaceForButton>
        {isAppPortocar && <ComplemetPolicy />}

        {isImportCilia && <ComplementImportCilia />}

        {showAuthorizeButton && <ComplementAuthorize />}

        {showCreateComplementButton && <ComplementCreateButton />}

        <SaveButton
          block
          loading={isLoading}
          onClick={onSave}
          disabled={saveButtonIsDisabled ?? !hasFormChange}
        >
          <FormattedMessage id="commons.entity.save" />
        </SaveButton>
      </SpaceForButton>

      {!!workorder?.customer && (
        <LGPDTermModal
          customerId={workorder?.customer.id}
          onClose={modalLgpdAction.close}
          open={modalLgpdOpen}
          onCallback={submitAllForms}
        />
      )}
    </>
  );
};

export default WorkorderTabExtraAction;
